import { useRef, useEffect } from 'react';
import { AnyIfEmpty } from 'react-redux';

const usePrevious = (value?: AnyIfEmpty<object>) => {
    const ref = useRef();

    useEffect(() => {
        ref.current = value;
    }, [value]);

    // Return previous value (happens before update in useEffect above)
    return ref.current;
};

export default usePrevious;
